import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PatientCard from "../../components/PaitientCard/PatientCard";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Timeline.scss";
import styles from "../../../src/pages/console/Console.module.scss";
import PillNav from "../../components/PillNav/PillNav";

import { CheckToken } from "../../../src/pages/login/AccessToken";
import Timeline from "./Timeline";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { toast } from "react-toastify";
import { organizedArrayByHiTypes } from "../../pages/doctor-console/Utils/UtilsFunctions";
import { Grid } from "@mui/material";

// Set pdfMake fonts
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

function TimelineMain(props) {
  // const  state  = props.stateProps;
  const careContextList = props.careContextList;
  const timelineData = props.timelineData;
  const timelineDataAbdm = props.timelineDataAbdm;
  console.log("Timeline main Page Patient data", props.patientData);
  console.log("Timeline main Page Console", careContextList);
  const [fhirArrays, setFhirArrays] = useState([]);
  const [data, setData] = useState(null);
  const [abdmData, setAbdmData] = useState(null);
  const [abdmSummary, setAbdmSummary] = useState(false);
  const [s3Summary, setS3Summary] = useState(false);
  const organizedArray = props.organizedArray;
  const [summaryData, setSummaryData] = useState([]);
  const [summaryToDisplay, setSummaryToDisplay] = useState(null);
  const [top3Questions, setTop3Questions] = useState(null);
  const [isSummaryGenerated, setIsSummaryGenerated] = useState(false);
  const [sourceId, setSourceId] = useState("");
  // var stateVal = state;
  const history = useHistory();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [isAiEnabled, setIsAiEnabled] = useState(
    sessionStorage.getItem("isAiEnabled") !== undefined &&
      sessionStorage.getItem("isAiEnabled") !== null
      ? JSON.parse(sessionStorage.getItem("isAiEnabled"))
      : false
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(async () => {
    if (timelineData === null) {
      const selectedValues = careContextList.map(
        (item) => item.care_context_reference
      );
      let fhirArray = null;
      if (selectedValues.length > 0) {
        const fhirStringToJson = (fhirData) => {
          console.log("Fhir Data From Doctor's Console", fhirData);
          console.log("FhirData Length", fhirData.length);

          const newData = [];

          fhirData.forEach((entry) => {
            const parsedEntry = {};

            Object.entries(entry).forEach(([keyId, arrayValues]) => {
              //key id is something like FHIR with ID ab37cb91-7d05-4aab-b0d9-fa739dd54288,inside this we have array of objects for a particular resourseType like Composition,patient, Organization etc
              // console.log("Array values in Past Visit", arrayValues);
              //maybe value inside each resource type is not coming in js format so we are modifying it
              const parsedArray = arrayValues.map((item) => {
                const parsedItem = {};

                Object.entries(item).forEach(([innerKey, value]) => {
                  parsedItem[innerKey] = value;
                });

                return parsedItem;
              });
              // console.log("ParsedArray", parsedArray);
              const composition = parsedArray.find((item) =>
                item.hasOwnProperty("Composition")
              );

              let key = "Display not found";

              if (composition) {
                const compositionSnomedCode =
                  composition?.Composition?.code?.[0]?.code;

                switch (compositionSnomedCode) {
                  case "440545006":
                    key = "Prescription";
                    break;
                  case "721981007":
                    key = "Diagnostic Report";
                    break;
                  case "371530004":
                    key = "OP Consultation";
                    break;
                  case "373942005":
                    key = "Discharge Summary";
                    break;
                  case "41000179103":
                    key = "Immunization Record";
                    break;
                  case "419891008":
                    key = "Record artifact";
                    break;
                  case "1156871006":
                    key = "Wellness Record";
                    break;
                }
              }

              parsedEntry[key] = parsedArray;
              const compositionDate =
                composition?.Composition?.date?.split("T")[0];

              const dateEntry = newData.find((item) => item[compositionDate]);
              console.log("date Entry in doctors console", dateEntry);
              if (dateEntry) {
                dateEntry[compositionDate].push(parsedEntry);
              } else {
                newData.push({ [compositionDate]: [parsedEntry] });
              }
            });
          });

          console.log("New S3 Bucket Before Modification", newData);
          return newData;
        };
        try {
          if (selectedValues.length > 0) {
            // Form the request body
            const requestBody = {
              carecontexts: selectedValues,
            };

            // Make the GET request using Axios
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}get_fhir_based_on_carecontexts_new/`,
              requestBody,
              {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                  // Add other headers if needed
                },
              }
            );

            // Handle the response data
            console.log("API response For Retrieve Fhir:", response.data);
            if (response.data.Status === "completed") {
              fhirArray = response.data.response_list;

              fhirArray.map((fhirData) => {
                const newData = fhirStringToJson(fhirData["fhir_data"]);
                fhirData["fhir_data"] = newData;
              });
              console.log("Parsed Fhir Array", fhirArray);
              const copiedFhirArray = JSON.parse(JSON.stringify(fhirArray));

              const modifiedFhirArray =
                organizedArrayByHiTypes(copiedFhirArray);

              const modifiedFhirArrayWithoutDocs = modifiedFhirArray.map(
                (fhirData) => {
                  const modifiedDataWithoutDocs = {
                    ...fhirData,
                    fhir_data: fhirData["fhir_data"].map((dateObject) => {
                      return Object.entries(dateObject).reduce(
                        (acc, [dateKey, hiTypeVal]) => {
                          if (Array.isArray(hiTypeVal)) {
                            const modifiedItems = hiTypeVal.map((item) => {
                              // Deep copy the item to avoid modifying the original
                              const newItem = JSON.parse(JSON.stringify(item));

                              return Object.entries(newItem).reduce(
                                (itemAcc, [key, valueObj]) => {
                                  console.log("Key", key);
                                  console.log("value Array", valueObj);
                                  const newModifiedValueObj = { ...valueObj };

                                  if (
                                    newModifiedValueObj["DocumentReference"]
                                  ) {
                                    delete newModifiedValueObj[
                                      "DocumentReference"
                                    ];
                                  }
                                  if (newModifiedValueObj["Binary"]) {
                                    delete newModifiedValueObj["Binary"];
                                  }

                                  if (key === "Diagnostic Report") {
                                    if (
                                      newModifiedValueObj["DiagnosticReport"]
                                    ) {
                                      newModifiedValueObj[
                                        "DiagnosticReport"
                                      ].map((diagObj, ind) => {
                                        if (diagObj["report_data"]) {
                                          delete newModifiedValueObj[
                                            "DiagnosticReport"
                                          ][ind]["report_data"];
                                        }
                                      });
                                    }
                                  }

                                  itemAcc[key] = newModifiedValueObj;
                                  return itemAcc;
                                },
                                {}
                              );
                            });
                            acc[dateKey] = modifiedItems;
                          }
                          return acc;
                        },
                        {}
                      );
                    }),
                  };
                  return modifiedDataWithoutDocs;
                }
              );
              //removing fhirList and past visiot so that it should not be uploaded to the chatpdf
              modifiedFhirArrayWithoutDocs.map((data) => {
                if (data.fhirList) {
                  delete data.fhirList;
                }
                if (data.past_visit) {
                  delete data.past_visit;
                }
              });
              console.log(
                "Modified with out docs",
                modifiedFhirArrayWithoutDocs
              );
              // console.log("Modified withdocs", modifiedFhirArray);
              console.log("Modified withdocs", modifiedFhirArray);

              setSummaryData((prevData) => {
                return [...prevData, ...modifiedFhirArrayWithoutDocs];
              });
              setData(modifiedFhirArray);
              setS3Summary(true);

              props.handleTimelineData(modifiedFhirArray);
            }
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          // Handle errors, e.g., display an error message to the user
        }
      } else {
        setData([]);
        setS3Summary(true);
        props.handleTimelineData(null);
      }
    } else {
      const copiedFhirArray = JSON.parse(JSON.stringify(timelineData));

      const modifiedFhirArrayWithoutDocs = copiedFhirArray.map((fhirData) => {
        const modifiedDataWithoutDocs = {
          ...fhirData,
          fhir_data: fhirData["fhir_data"].map((dateObject) => {
            return Object.entries(dateObject).reduce(
              (acc, [dateKey, hiTypeVal]) => {
                if (Array.isArray(hiTypeVal)) {
                  const modifiedItems = hiTypeVal.map((item) => {
                    // Deep copy the item to avoid modifying the original
                    const newItem = JSON.parse(JSON.stringify(item));

                    return Object.entries(newItem).reduce(
                      (itemAcc, [key, valueObj]) => {
                        console.log("Key", key);
                        console.log("value Array", valueObj);
                        const newModifiedValueObj = { ...valueObj };

                        if (newModifiedValueObj["DocumentReference"]) {
                          delete newModifiedValueObj["DocumentReference"];
                        }
                        if (newModifiedValueObj["Binary"]) {
                          delete newModifiedValueObj["Binary"];
                        }

                        if (key === "Diagnostic Report") {
                          if (newModifiedValueObj["DiagnosticReport"]) {
                            newModifiedValueObj["DiagnosticReport"].map(
                              (diagObj, ind) => {
                                if (diagObj["report_data"]) {
                                  delete newModifiedValueObj[
                                    "DiagnosticReport"
                                  ][ind]["report_data"];
                                }
                              }
                            );
                          }
                        }

                        itemAcc[key] = newModifiedValueObj;
                        return itemAcc;
                      },
                      {}
                    );
                  });
                  acc[dateKey] = modifiedItems;
                }
                return acc;
              },
              {}
            );
          }),
        };
        return modifiedDataWithoutDocs;
      });
      //removing fhirList and past visiot so that it should not be uploaded to the chatpdf
      modifiedFhirArrayWithoutDocs.map((data) => {
        if (data.fhirList) {
          delete data.fhirList;
        }
        if (data.past_visit) {
          delete data.past_visit;
        }
      });

      setSummaryData((prevData) => {
        return [...prevData, ...modifiedFhirArrayWithoutDocs];
      });
      setData(timelineData);
      setS3Summary(true);
    }
  }, [careContextList]);

  useState(() => {
    if (timelineDataAbdm === null) {
      // console.log("Timeline Data Abdm Null");
      if (organizedArray === null) {
        setAbdmSummary(true);

        setAbdmData(null);

        props.handleTimelineDataAbdm(null);
        return;
      }
      const copiedArray = JSON.parse(JSON.stringify(organizedArray));
      const modifiedFhirArray = organizedArrayByHiTypes(copiedArray);

      const modifiedFhirArrayWithoutDocs = modifiedFhirArray.map((fhirData) => {
        const modifiedDataWithoutDocs = {
          ...fhirData,
          fhir_data: fhirData["fhir_data"].map((dateObject) => {
            return Object.entries(dateObject).reduce(
              (acc, [dateKey, hiTypeVal]) => {
                if (Array.isArray(hiTypeVal)) {
                  const modifiedItems = hiTypeVal.map((item) => {
                    // Deep copy the item to avoid modifying the original
                    const newItem = JSON.parse(JSON.stringify(item));

                    return Object.entries(newItem).reduce(
                      (itemAcc, [key, valueObj]) => {
                        console.log("Key", key);
                        console.log("value Array", valueObj);
                        const newModifiedValueObj = { ...valueObj };

                        if (newModifiedValueObj["DocumentReference"]) {
                          delete newModifiedValueObj["DocumentReference"];
                        }
                        if (newModifiedValueObj["Binary"]) {
                          delete newModifiedValueObj["Binary"];
                        }

                        if (key === "Diagnostic Report") {
                          if (newModifiedValueObj["DiagnosticReport"]) {
                            newModifiedValueObj["DiagnosticReport"].map(
                              (diagObj, ind) => {
                                if (diagObj["report_data"]) {
                                  delete newModifiedValueObj[
                                    "DiagnosticReport"
                                  ][ind]["report_data"];
                                }
                              }
                            );
                          }
                        }

                        itemAcc[key] = newModifiedValueObj;
                        return itemAcc;
                      },
                      {}
                    );
                  });
                  acc[dateKey] = modifiedItems;
                }
                return acc;
              },
              {}
            );
          }),
        };
        return modifiedDataWithoutDocs;
      });

      // console.log("Modified with out docs", modifiedFhirArrayWithoutDocs);
      // console.log("Modified withdocs", modifiedFhirArray);
      // const newArray2 = [...summaryData, ...modifiedFhirArrayWithoutDocs];
      // console.log("New Modified Array2", newArray2);

      setSummaryData((prevData) => {
        return [...prevData, ...modifiedFhirArrayWithoutDocs];
      });
      setAbdmData(modifiedFhirArray);
      setAbdmSummary(true);
      props.handleTimelineDataAbdm(modifiedFhirArray);
    } else {
      const copiedArray = JSON.parse(JSON.stringify(timelineDataAbdm));
      const modifiedFhirArrayWithoutDocs = copiedArray.map((fhirData) => {
        const modifiedDataWithoutDocs = {
          ...fhirData,
          fhir_data: fhirData["fhir_data"].map((dateObject) => {
            return Object.entries(dateObject).reduce(
              (acc, [dateKey, hiTypeVal]) => {
                if (Array.isArray(hiTypeVal)) {
                  const modifiedItems = hiTypeVal.map((item) => {
                    // Deep copy the item to avoid modifying the original
                    const newItem = JSON.parse(JSON.stringify(item));

                    return Object.entries(newItem).reduce(
                      (itemAcc, [key, valueObj]) => {
                        console.log("Key", key);
                        console.log("value Array", valueObj);
                        const newModifiedValueObj = { ...valueObj };

                        if (newModifiedValueObj["DocumentReference"]) {
                          delete newModifiedValueObj["DocumentReference"];
                        }
                        if (newModifiedValueObj["Binary"]) {
                          delete newModifiedValueObj["Binary"];
                        }

                        if (key === "Diagnostic Report") {
                          if (newModifiedValueObj["DiagnosticReport"]) {
                            newModifiedValueObj["DiagnosticReport"].map(
                              (diagObj, ind) => {
                                if (diagObj["report_data"]) {
                                  delete newModifiedValueObj[
                                    "DiagnosticReport"
                                  ][ind]["report_data"];
                                }
                              }
                            );
                          }
                        }

                        itemAcc[key] = newModifiedValueObj;
                        return itemAcc;
                      },
                      {}
                    );
                  });
                  acc[dateKey] = modifiedItems;
                }
                return acc;
              },
              {}
            );
          }),
        };
        return modifiedDataWithoutDocs;
      });
      setAbdmData(timelineDataAbdm);

      // const newArray2 = [...summaryData, ...modifiedFhirArrayWithoutDocs];
      // console.log("New Modified Array2", newArray2);
      setSummaryData((prevData) => {
        return [...prevData, ...modifiedFhirArrayWithoutDocs];
      });
      setAbdmSummary(true);
    }
  }, [organizedArray]);

  console.log("Summary Data", summaryData);
  console.log("S3 and abdm timeline Data", timelineData, timelineDataAbdm);

  useEffect(() => {
    console.log("S3 and abdm summary", s3Summary, abdmSummary);
    if (s3Summary && abdmSummary) {
      const updatedSummaryData = [
        { patientData: props.patientData },
        ...summaryData,
      ];

      console.log("On Submit Called");
      onSubmit(updatedSummaryData);
    }
  }, [summaryData, s3Summary, abdmSummary]);

  const formatContent = (content) => {
    // Remove asterisks and leading/trailing whitespace
    const formattedContent = content.replace(/[*]/g, "").trim();

    // Optionally, replace '**' for bold text with plain text
    const cleanContent = formattedContent.replace(/\*\*/g, "");

    return cleanContent;
  };
  const onSubmit = async (summary) => {
    console.log("Inside on submit function", summary);
    const summaryString = JSON.stringify(summary);
    let postBody = {
      content:
        "Please provide texual summary of the patient including demographic details like name ,gender and birthdate and other details like medications and diagnostics based on the fhir string provided.In the patientdata we provide patient's information.Give point wise 1.Personal details newline 2.Medications newline 3.Diagnostics.Please dont use any other extra characters",
    };
    postBody.content += ` Fhir String: ${summaryString}`;
    var top3QuestionsPostBody = {
      content:
        "I give you a fhir string.Now as a medical practitioner you are suppossed to return me top three questions to be asked to patient based on the passed data.Give the result in array format where three entries will be there for three questions.",
    };
    top3QuestionsPostBody.content += ` Fhir String: ${summaryString}`;
    if (Token() && isAiEnabled) {
      try {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}generate_gemini_text/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Gemini Response for summary", response);

          if (response.status === 200) {
            const answerContent = response.data.answer;

            // Format the content
            const formattedAnswer = formatContent(answerContent);

            setSummaryToDisplay(formattedAnswer);
          }
        }
        const top3QuestionsResponse = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}generate_gemini_text/`,
          top3QuestionsPostBody,
          { headers: headers }
        );
        if (top3QuestionsResponse) {
          console.log(
            "Gemini Response for top 3 questions",
            top3QuestionsResponse
          );

          if (top3QuestionsResponse.status === 200) {
            let questionsArray = [];
            if (top3QuestionsResponse.data.answer) {
              const jsonStringMatch = top3QuestionsResponse.data.answer.match(
                /```json\n([\s\S]*?)\n```/
              );

              if (jsonStringMatch) {
                questionsArray = JSON.parse(jsonStringMatch[1].trim());
                console.log(questionsArray);
              } else {
                console.log("No JSON array found in the response");
              }
            }

            setTop3Questions(questionsArray);
            setIsSummaryGenerated(true);
          }
        }
      } catch (err) {
        console.log(err);
        toast.error(err);
      }
    }
  };

  console.log("Timeline MAin Pagggggggggeeee", summaryToDisplay, top3Questions);
  console.log("Timeline Data", data);
  console.log(
    "Other Data ,isAienabled,s3Summary,abdmSummary",
    isAiEnabled,
    s3Summary,
    abdmSummary
  );
  return (
    <>
      <Grid container sx={{ width: "100%" }}>
        {summaryData !== null &&
        ((isAiEnabled &&
          isSummaryGenerated &&
          summaryToDisplay !== null &&
          top3Questions !== null &&
          top3Questions !== undefined) ||
          (!isAiEnabled && s3Summary && abdmSummary)) ? (
          <Grid item xs={12}>
            <Timeline
              data={data}
              abdmData={abdmData}
              summary={summaryToDisplay}
              questions={top3Questions}
              careContextList={careContextList}
            />
          </Grid>
        ) : (
          <Grid item xs={12}>
            <h1 className="fetching-data">Fetching Timeline Data...</h1>
          </Grid>
        )}
      </Grid>

      {/* ... Other parts of your component ... */}
    </>
  );
}

export default TimelineMain;
